import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { BaseAuthComponent } from '../../../layouts/default/layouts/guest/pages/home/components/base-auth.component';
import { Response } from '@shared/models/response.model';
import { NotificationStatistics } from '@shared/interfaces/notification-statistics.interface';
import { NotificationsDropdownService } from '@shared/components/header/header-desktop/components/notifications-dropdown/notifications-dropdown.service';
import { range } from 'rxjs';
import { HeaderService } from '@shared/services/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseAuthComponent implements OnInit, AfterViewInit {
  notificationsUnseen: number = null;
  cartListLength: number = null;
  userInfo: boolean = false;
  menuHeight: number;
  userInfoHeight: number;
  mobileAppBannerHeight: number;

  constructor(
    public notificationsService: NotificationsDropdownService,
    public header: HeaderService
  ) {
    super();
  }

  ngOnInit() {
    if (this.storage.user) {
      this.userInfo = !this.isProfileCempleted();
      this.storage.changeUserInfo(this.userInfo);
      this.storage._userInfo.subscribe((ui) => {
        this.userInfo = ui;
        if (this.userInfo === false) {
          this.calculateHeaderHeights();
        }
      });

      const source = range(1, 1);
      const subInterval = source.subscribe((el) => {
        this.getNotificationsStatistics();
      });
      this.someSubscriptions.add(subInterval);
    }
  }

  ngAfterViewInit(): void {
    this.calculateHeaderHeights();
  }

  isProfileCempleted() {
    return this.storage.user &&
      this.storage.user.name != null &&
      this.storage.user.surname != null &&
      this.storage.user.birthday != null &&
      this.storage.user.origin_country != null &&
      this.storage.user.tax_residence != null
      ? true
      : false;
  }

  calculateHeaderHeights(immediate: boolean = false) {
    if (window.innerWidth >= 886) {
      this.menuHeight = 75;
    } else {
      this.menuHeight = 64;
    }

    if (this.userInfo) {
      this.userInfoHeight = document.querySelector<HTMLElement>('.user__info').offsetHeight;
    } else {
      this.userInfoHeight = 0;
    }

    const mobileAppBanner = document.querySelector<HTMLElement>('.mobile-app-banner');
    if (mobileAppBanner) {
      this.mobileAppBannerHeight = mobileAppBanner.offsetHeight;
    } else {
      this.mobileAppBannerHeight = 0;
    }

    setTimeout(() => {
      document.querySelector<HTMLElement>('.layout__wrapper').style.paddingTop =
        String(this.menuHeight + this.userInfoHeight + this.mobileAppBannerHeight + 2) + 'px';

      document.querySelector<HTMLElement>('.header-desktop .header').style.top =
        String(this.userInfoHeight + this.mobileAppBannerHeight) + 'px';
      document.querySelector<HTMLElement>('.header-mobile').style.top =
        String(this.userInfoHeight + this.mobileAppBannerHeight) + 'px';
    }, immediate ? 100 : 1000);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.calculateHeaderHeights(true);
  }

  getNotificationsStatistics() {
    if (this.storage.user) {
      const subNotificationsStatistics = this.notificationsService
        .getNotificationsStatistics()
        .subscribe((el: Response<NotificationStatistics>) => {
          this.notificationsUnseen = el.data.unseen;
        });
      this.someSubscriptions.add(subNotificationsStatistics);
    }
  }

  setCartListLength(event) {
    this.cartListLength = event;
  }
}
